import React, {Component} from "react";
import {
    Grid,
    Paper,
    Divider,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions, Button, Dialog, Typography, withMobileDialog
} from "@material-ui/core";
import {message} from "antd";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import {withStyles} from "@material-ui/core/styles";
import Intigrate from "./Intigrate";
import AvatarEditor from "react-avatar-editor";
import Dropzone from "react-dropzone";
import ProfileImage from "./ProfileImage";
import PersonalInfo from "./PersonalInfo";
import Intigration from "./Intigration";
import PasswordMgt from "./PasswordMgt";
import AccessLevel from "./AccessLevel";
import PropTypes from "prop-types";
import Can from "../../services/RolePermissionService";
let fileDownload = require("js-file-download");


const styles = theme => ({
    root: {
        flexGrow: 1,
        ...theme.mixins.gutters(),
        height: "99%",
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        //textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    slider: {
        padding: "10px 0px",
    },
});


class Account extends Component {

    constructor(props) {
        super(props);
        this.state = {
            InfoEdit: true,
            passwordEdit: true,
            copied: false,
            open: false,
            proPicDialog: false,
            mEndpoint: "",
            oldPassword: "",
            newPassword: "",
            personalInfo: {
                given_name: "",
                family_name: "",
                email: "",
                "custom:nic": "",
                phone_number: ""
            },
            scale:0.2,
            newPicture: ""
        };
        this.infoEditStateChange = this.infoEditStateChange.bind(this);
        this.passwordEditStateChange = this.passwordEditStateChange.bind(this);
        this.copyStateChange = this.copyStateChange.bind(this);
        this._setEndPoint = this._setEndPoint.bind(this);
        this._generateApiKey = this._generateApiKey.bind(this);
        this._onChange = this._onChange.bind(this);
        this._changePassword = this._changePassword.bind(this);
        this._cancelPasswordChange = this._cancelPasswordChange.bind(this);
        this._personalInfoOnChange = this._personalInfoOnChange.bind(this);
        this._cancelInfoChange = this._cancelInfoChange.bind(this);
        this._submitInfoChange = this._submitInfoChange.bind(this);
        this._downloadPublicKey = this._downloadPublicKey.bind(this);
        this._downloadPrivateKey = this._downloadPrivateKey.bind(this);
        this._generatePrivateKey = this._generatePrivateKey.bind(this);
    }

    componentWillMount() {
        if (!this.props.Merchant.id && !this.props.Merchant.apiKey) {
            this.props.getMerchantDetail();
        }

        let user = this.props.userInfo;
        if (!this.props.picture) {
            this.props.getUserPicture(user.id);
        }
        this.setState({
            personalInfo: {
                given_name: user.fname,
                family_name: user.lname,
                email: user.email,
                "custom:nic": user.nic,
                phone_number: user.mobile
            }
        });
    }

    infoEditStateChange() {
        this.setState({InfoEdit: !this.state.InfoEdit});
        console.log("infoEditStateChange", this.state.InfoEdit);
    }

    passwordEditStateChange() {
        this.setState({passwordEdit: !this.state.passwordEdit});
        console.log("passwordEditStateChange", this.state.InfoEdit);
    }

    copyStateChange() {
        this.setState({copied: true});
        console.log("copyStateChange", this.state.copied);
    }

    mouseLeave = () => {
        this.setState({copied: false});
    };

    handleClickOpen = () => {
        this.setState({open: true, mEndpoint: this.props.Merchant.endPoint});
    };

    endPointHandleChange = (e) => {
        this.setState({mEndpoint: e.target.value});
    };

    _onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    _personalInfoOnChange(e) {
        this.setState({
            personalInfo:{
                ...this.state.personalInfo,
                [e.target.name] : e.target.value
            }
        });
        console.debug(this.state.personalInfo);
    }

    _cancelInfoChange(){
        let user = this.props.userInfo;
        this.setState({
            InfoEdit: true,
            personalInfo:{
                given_name: user.fname,
                family_name: user.lname,
                email: user.email,
                "custom:nic": user.nic,
                phone_number: user.mobile
            }
        });
    }

    _submitInfoChange(){
        let data = this.state.personalInfo;
        let userAttArr = [];

        if(data.email && data.family_name && data.given_name && data.phone_number && data["custom:nic"]){
            for (var keyName in data) {
                userAttArr.push({
                    "Name": keyName,
                    "Value": data[keyName]
                });
            }

            this.props.userChangeAttribute(this.props.userInfo.id, userAttArr);
            this.setState({InfoEdit: true});
        }else {
            message.warning("All data Mandatory");
        }
    }

    handleClose = () => {
        this.setState({open: false});
    };

    _setEndPoint() {
        this.props.setEndpoint(this.state.mEndpoint);
        this.setState({open: false, mEndpoint: ""});
    }

    _generateApiKey() {
        this.props.generateApiKey();
    }

    _changePassword() {
        if (!this.state.oldPassword) {
            message.warning("Old Password field Mandatory");
        } else if (!this.state.newPassword) {
            message.warning("New Password field Mandatory");
        } else {
            this.setState({passwordEdit: true});
            this.props.changePassword(this.state);
            this.setState({oldPassword: "", newPassword: ""});
        }
    }

    _cancelPasswordChange() {
        this.setState({oldPassword: "", newPassword: "", passwordEdit: true});
    }

    handleUpload = (image) => {
        this.setState({
            proPicDialog: false,
            newPicture: ""
        });
        this.props.uploadUserPicture(this.props.userInfo.id, image);
    }


    handleProPicDialogOpen = () => {
        this.setState({proPicDialog: true});
    }

    handleProPicDialogClose = () => {
        this.setState({proPicDialog: false, newPicture:""});
    }

    handleScaleChange = (value) => {
        this.setState({ scale: value });
    };

    handleDrop = dropped => {
        this.setState({ newPicture: dropped[0] });
    }

    onClickSave = () => {
        if (this.editor) {
            const canvas = this.editor.getImageScaledToCanvas().toDataURL();
            fetch(canvas)
                .then(res => res.blob())
                .then(blob => (
                    //this.props.uploadUserPicture(this.props.userInfo.id, blob)
                    this.handleUpload(blob)
                ));
        }
    }

    setEditorRef = (editor) => this.editor = editor

    _downloadPublicKey(){
        fileDownload(this.props.Merchant.publicKey, "directpay_dev_publicKey.pem");
    }

    _downloadPrivateKey(){
        fileDownload(this.props.Merchant.privateKey, "directpay_dev_privateKey.pem");
    }

    _generatePrivateKey(){
        this.props.generateMerchantKey(this.props.User);
    }


    render() {
        //console.debug("Account props", this.props);
        //console.debug("Account states", this.state);
        const {classes, fullScreen} = this.props;
        const baseStyle = {
            width: 200,
            height: 200,
            borderWidth: 2,
            borderColor: "#666",
            borderStyle: "dashed",
            borderRadius: 5
        };
        const activeStyle = {
            borderStyle: "solid",
            borderColor: "#6c6",
            backgroundColor: "#eee"
        };
        const rejectStyle = {
            borderStyle: "solid",
            borderColor: "#c66",
            backgroundColor: "#eee"
        };

        return (
            <div className={classes.root}>
                <Grid container spacing={40}>

                    <Grid item xs={12} sm={12} md={2} xl={2}>
                        <ProfileImage classes={classes} allProps={this.props} allState={this.state}
                            handleProPicDialogOpen={this.handleProPicDialogOpen}
                            handleUpload={this.handleUpload}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={24}>
                            <PersonalInfo classes={classes} allState={this.state} allProps={this.props}
                                cancelInfoChange={this._cancelInfoChange}
                                submitInfoChange={this._submitInfoChange}
                                infoChange={this._personalInfoOnChange}
                                stateChanger={this.infoEditStateChange}/>
                            <Can do="view" on='intigration'>
                                <Intigration classes={classes} allState={this.state} allProps={this.props}
                                    generateApiKey={this._generateApiKey} mouseLeave={this.mouseLeave}
                                    copyStateChange={this.copyStateChange} handleClickOpen={this.handleClickOpen}
                                    generatePriKey={this._generatePrivateKey}
                                    pubKeyDown={this._downloadPublicKey} priKeyDown={this._downloadPrivateKey}
                                />
                            </Can>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} xl={4}>
                        <Paper className={classes.paper} style={{"height": "auto"}}>
                            <Grid container direction="column" justify="space-between" alignItems="stretch"
                                spacing={24}>
                                <PasswordMgt classes={classes} allState={this.state} allProps={this.props}
                                    changePassword={this._changePassword} cancel={this._cancelPasswordChange}
                                    infoChange={this._onChange} stateChanger={this.passwordEditStateChange}/>
                                <Divider variant="middle"/>
                                <AccessLevel classes={classes} roleList={this.props.userInfo.userRoles}/>
                            </Grid>
                        </Paper>
                    </Grid>

                </Grid>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    fullScreen={fullScreen}
                >
                    <DialogTitle id="form-dialog-title">Set Endpoint</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            please enter your Confirmation Endpoint here.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            value={this.state.mEndpoint ? this.state.mEndpoint : ""}
                            onChange={this.endPointHandleChange}
                            id="ednpoint"
                            label="ENDPOINT"
                            type="text"
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this._setEndPoint} color="primary">
                            Set
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog
                    open={this.state.proPicDialog}
                    onClose={this.handleProPicDialogClose}
                    aria-labelledby="responsive-dialog-title"
                    fullScreen={fullScreen}
                >
                    <DialogTitle id="form-dialog-title">Set New Picture</DialogTitle>
                    <DialogContent>

                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="flex-start"
                        >

                            <Grid item>

                                {this.state.newPicture ?
                                    <div>
                                        <AvatarEditor
                                            ref={this.setEditorRef}
                                            image={this.state.newPicture}
                                            width={250}
                                            height={250}
                                            border={30}
                                            borderRadius={200}
                                            color={[149, 165, 166, 2]} // RGBA
                                            scale={this.state.scale}
                                            rotate={0}
                                        />
                                        <Typography id="label">Scale</Typography>
                                        <Slider
                                            min={-2}
                                            max={2}
                                            step={0.1}
                                            tooltip={false}
                                            value={this.state.scale}
                                            onChange={this.handleScaleChange}
                                        />
                                    </div>
                                    :
                                    <Dropzone accept="image/*" onDrop={this.handleDrop.bind(this)}>
                                        {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
                                            let styles = {...baseStyle};
                                            styles = isDragActive ? {...styles, ...activeStyle} : styles;
                                            styles = isDragReject ? {...styles, ...rejectStyle} : styles;

                                            return (
                                                <div
                                                    {...getRootProps()}
                                                    style={styles}
                                                >
                                                    <input {...getInputProps()} />
                                                    <div  style={{"textAlign":"center"}}>
                                                        {isDragAccept ? "Drop" : "Drag"} Picture here or click to add Picture
                                                    </div>
                                                    {isDragReject && <div>Unsupported file type...</div>}
                                                </div>
                                            );
                                        }}
                                    </Dropzone>
                                }
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleProPicDialogClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onClickSave} color="primary">
                            Set
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}

Intigrate.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(Account));